<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <div>
        Made with <img src="@/assets/images/heart.png" alt="love" class="heart" @click="showModal = true"> in San Francisco.
      </div>
      <a href="https://gitlab.com/iKnowMagic/portfolio" target="_blank" class="gitlab">
        <img src="@/assets/images/gitlab.png" alt="GitLab">
      </a>
      <router-link to="/contact" class="cemail">
       <img src="@/assets/images/email_white.svg" alt="Email" class="svg-color">
      </router-link>
    </div>

    <modal v-show="showModal" @close-modal="showModal = false">
      <div class="box has-text-centered">
        ...with <img src="@/assets/images/heart.png" alt="love" class="heart"> and Vue, Bulma, Webpack, Sass, Photoswipe.
        <br> Source for project hosted at
        <a href="https://gitlab.com/iKnowMagic/portfolio" target="_blank" class="bold">GitLab</a>.
        <br> <br> Included projects use different technologies such as Angular, Sass, Bootstrap, PHP, MySQL,
        Drupal, custom-made Drupal modules and custom Gulp workflows.
      </div>
    </modal>
  </footer>
</template>

<script>
  import Modal from '@/components/Modal'

  export default {
    name: 'Footer',
    components: {
      Modal
    },
    methods: {
      escapeKeyListener(e) {
        if (e.keyCode === 27) {
          this.showModal = false;
        }
      }
    },
    created() {
      document.addEventListener('keyup', this.escapeKeyListener);
    },
    data() {
      return {
        showModal: false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue